'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/10/19.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShopDetail = require('redux/modules/experienceShopDetail');

var experienceShopDetailActions = _interopRequireWildcard(_experienceShopDetail);

var _reactRouterRedux = require('react-router-redux');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopProductList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.isSoldOut) {
      filter = (0, _extends3.default)({}, filter, { isSoldOut: query.isSoldOut });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.orderItem) {
      orderItem = query.orderItem;
    }
    if (query.direction) {
      direction = query.direction;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('体验店艺品')));
    promises.push(dispatch(experienceShopDetailActions.load(params.experienceShopId, filter, {
      orderItem: orderItem,
      direction: direction
    }, experienceShopDetailActions.isLoaded(getState()), page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.experienceShopDetail.data
  };
}, (0, _extends3.default)({}, experienceShopDetailActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopProductList, _Component);

  function ExperienceShopProductList() {
    (0, _classCallCheck3.default)(this, ExperienceShopProductList);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopProductList).call(this));
  }

  (0, _createClass3.default)(ExperienceShopProductList, [{
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      switch (val) {
        case 'sold':
          if (routerPush) {
            if (!location.query.isSoldOut || location.query.isSoldOut === '1') {
              routerPush({ pathname: location.pathname, query: { isSoldOut: '0' } });
            }
            /* if (location.query.isSoldOut === '0') {
             routerPush({pathname: location.pathname, query: {}});
             } else {
             routerPush({pathname: location.pathname, query: {isSoldOut: '0'}});
             } */
          }
          break;
        case 'soldOut':
          if (routerPush) {
            if (!location.query.isSoldOut || location.query.isSoldOut === '0') {
              routerPush({ pathname: location.pathname, query: { isSoldOut: '1' } });
            }
            /* if (location.query.isSoldOut === '1') {
             routerPush({pathname: location.pathname, query: {}});
             } else {
             routerPush({pathname: location.pathname, query: {isSoldOut: '1'}});
             } */
          }
          break;
        case 'zw':
          break;
        default:
          if (routerPush) {
            var query = {};
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.findValue = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
        this.scrollToAnchor('homePageOrderBar');
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var data = _props4.data;
      var location = _props4.location;
      // console.log(JSON.stringify(params));

      var orderArray = [{ id: '', text: '全部艺品' }, { id: 'sold', text: '在售产品', soldId: '0' }, { id: 'soldOut', text: '下架产品', soldId: '1' }, { id: 'zw', text: '' }];
      var content = '';
      var listContent = '';
      var totalPageNumber = 1;
      var currentPage = 0;
      if (data) {
        // console.log(data);
        var experienceShopDetail = data.experienceShopDetail;
        var experienceShopDetailError = data.experienceShopDetailError;
        var experienceShopDetailProductList = data.experienceShopDetailProductList;
        var experienceShopDetailProductListError = data.experienceShopDetailProductListError;
        var experienceShopDetailProductListRecordCount = data.experienceShopDetailProductListRecordCount;
        var experienceShopDetailProductListPagesize = data.experienceShopDetailProductListPagesize;

        if (experienceShopDetailError) {
          content = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopDetailError });
        } else if (experienceShopDetail instanceof Array && experienceShopDetail.length > 0) {
          content = _react2.default.createElement(_components.ExperienceShopDetailComponent, { backgroundImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/tydback.jpg',
            data: experienceShopDetail[0] });
        } else {
          content = _react2.default.createElement(_components.ErrorLabel, { text: '获取到的数据无法解析' });
        }

        if (experienceShopDetailProductListError) {
          listContent = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopDetailProductListError });
        } else if (experienceShopDetailProductList instanceof Array) {
          listContent = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            experienceShopDetailProductList instanceof Array ? experienceShopDetailProductList.map(function (product, index) {
              return _react2.default.createElement(_components.ProductInfoOfExperienceShopDetail, { key: product.id, index: index, product: product });
            }) : _react2.default.createElement(
              'li',
              { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
              '未搜索到相关艺品'
            )
          );
          if (location.query && !isNaN(parseInt(location.query.page, 10))) {
            currentPage = parseInt(location.query.page, 10);
          }
          totalPageNumber = parseInt(experienceShopDetailProductListRecordCount / experienceShopDetailProductListPagesize, 10);
          if (experienceShopDetailProductListRecordCount % experienceShopDetailProductListPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/yyp_bg1.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/tyd.png'];
      return _react2.default.createElement(
        'div',
        null,
        content,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'homePageOrderBar' }),
        _react2.default.createElement(_components.HomePageOrderBar, { texts: orderArray, page: 'experienceShopDetail', onSearch: this.onSearch.bind(this),
          placeHolder: '请输入艺品名称',
          location: location,
          onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        listContent,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return ExperienceShopProductList;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  location: _react.PropTypes.object,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopProductList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopProductList/ExperienceShopProductList.js
 ** module id = 1477
 ** module chunks = 0
 **/